// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
    width: 250px;
    height: 100vh;
    background: #1a1a1a;
    color: #fff;
    position: fixed;
    left: 0;
    top: 0;
    padding: 1rem;
    transition: all 0.3s ease;
}

.sidebar-header {
    padding: 1rem 0;
    border-bottom: 1px solid #333;
    margin-bottom: 1rem;
}

.sidebar-header h2 {
    margin: 0;
    font-size: 1.5rem;
    font-weight: 600;
    color: #fff;
}

.sidebar-nav ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.sidebar-nav li {
    margin: 0.5rem 0;
}

.sidebar-nav li a {
    display: flex;
    align-items: center;
    padding: 0.75rem 1rem;
    color: #fff;
    text-decoration: none;
    border-radius: 0.5rem;
    transition: all 0.3s ease;
}

.sidebar-nav li a:hover {
    background: #333;
}

.sidebar-nav li.active a {
    background: #2563eb;
}

.sidebar-nav .icon {
    margin-right: 0.75rem;
    font-size: 1.25rem;
}

.sidebar-nav span {
    font-size: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/components/Sidebar.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,OAAO;IACP,MAAM;IACN,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;IACX,qBAAqB;IACrB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".sidebar {\n    width: 250px;\n    height: 100vh;\n    background: #1a1a1a;\n    color: #fff;\n    position: fixed;\n    left: 0;\n    top: 0;\n    padding: 1rem;\n    transition: all 0.3s ease;\n}\n\n.sidebar-header {\n    padding: 1rem 0;\n    border-bottom: 1px solid #333;\n    margin-bottom: 1rem;\n}\n\n.sidebar-header h2 {\n    margin: 0;\n    font-size: 1.5rem;\n    font-weight: 600;\n    color: #fff;\n}\n\n.sidebar-nav ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n\n.sidebar-nav li {\n    margin: 0.5rem 0;\n}\n\n.sidebar-nav li a {\n    display: flex;\n    align-items: center;\n    padding: 0.75rem 1rem;\n    color: #fff;\n    text-decoration: none;\n    border-radius: 0.5rem;\n    transition: all 0.3s ease;\n}\n\n.sidebar-nav li a:hover {\n    background: #333;\n}\n\n.sidebar-nav li.active a {\n    background: #2563eb;\n}\n\n.sidebar-nav .icon {\n    margin-right: 0.75rem;\n    font-size: 1.25rem;\n}\n\n.sidebar-nav span {\n    font-size: 1rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
